/* eslint-disable react/forbid-component-props */
import React, { useState, useEffect } from 'react'
import { Container, Typography, Box, LinearProgress } from '@mui/material'
import { Link as NavigateLink, Link } from 'react-router-dom'
import GuideLayout from './GuideLayout'
import { useAuth } from '../../../contexts/AuthContext'
import Development from './Pages/Development'

const PuppyDevelopment = () => {
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState(null)
  const { currentUser } = useAuth()

  useEffect(() => {
    setUser(currentUser)
    setLoading(false)
  }, [currentUser])

  return (
    <section>
      <Container fixed sx={{ marginTop: '50px' }}>
        <Typography mb={6} variant="h4">
          Training Guide
        </Typography>
        <NavigateLink to="/members">{'< Back to Members Area'}</NavigateLink>
        <Box sx={{ marginTop: 5 }}>
          {!!loading && <LinearProgress color="primary" />}
          <GuideLayout
            watermark={`Licensed to ${user?.firstName} ${user?.lastName}`}
          >
            <Box>
              <Typography align="center" mb={3}>
                PADs In Training Guide
              </Typography>
              <Typography variant="h4" align="center" mb={3}>
                Table of Contents
              </Typography>

              <Box
                component="ul"
                sx={{ pl: 3, listStyle: 'none', p: 0, m: 0, mb: 5 }}
              >
                <li style={{ listStyle: 'none', marginBottom: 10 }}>
                  <a href="#puppy-development">2. Puppy Development</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#development-periods">Development Periods</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#puppy-party">Puppy Socials/Parties</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#park-practice">Good Park Practice</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#body-language">
                    The Significance of Body Language
                  </a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#attacked">What To Do If Your Dog is Attacked</a>
                </li>
              </Box>
            </Box>
            <Development />
          </GuideLayout>
        </Box>
      </Container>
    </section>
  )
}

export default PuppyDevelopment
